import { RefString } from "@tblabs/truffle";


export class JobOfferDescriptionEntry
{
    public Label = new RefString();
    public Text = new RefString();

    constructor(label?: string, text?: string)
    {
        this.Label.value = label || "";
        this.Text.value = text || "";
    }
}
